/**
 * @generated SignedSource<<6ff33dcae23bb4b1005bb04a8895ab4b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PayoutAccountsViewQuery$variables = {
  fiatId?: string | null | undefined;
};
export type PayoutAccountsViewQuery$data = {
  readonly payoutAccounts: ReadonlyArray<{
    readonly bankName: string | null | undefined;
    readonly bic: string | null | undefined;
    readonly fiat: {
      readonly id: string;
      readonly symbol: string | null | undefined;
    };
    readonly iban: string;
    readonly id: string;
    readonly name: string | null | undefined;
  }> | null | undefined;
};
export type PayoutAccountsViewQuery = {
  response: PayoutAccountsViewQuery$data;
  variables: PayoutAccountsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fiatId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "fiatId",
        "variableName": "fiatId"
      }
    ],
    "concreteType": "PayoutAccount",
    "kind": "LinkedField",
    "name": "payoutAccounts",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bankName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "iban",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bic",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Fiat",
        "kind": "LinkedField",
        "name": "fiat",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "symbol",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PayoutAccountsViewQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PayoutAccountsViewQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "22739ff480f634997e9e23603a6c3148",
    "id": null,
    "metadata": {},
    "name": "PayoutAccountsViewQuery",
    "operationKind": "query",
    "text": "query PayoutAccountsViewQuery(\n  $fiatId: ID\n) {\n  payoutAccounts(fiatId: $fiatId) {\n    id\n    name\n    bankName\n    iban\n    bic\n    fiat {\n      id\n      symbol\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "aaab681a730d6e3e0367771a089ebb6b";

export default node;
